import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { PopupData } from "./popup.data";

@Injectable()
export class PopupService {
    private alert: Subject<PopupData> = new Subject<PopupData>();
    public alert$: Observable<PopupData>;

    constructor() {
        this.alert$ = this.alert.asObservable();
    }

    public publishAlert(title: string, message: string): void {
        let alertData: PopupData = new PopupData();
        alertData.isVisible = true;
        alertData.title = title;
        alertData.message = message;

        this.alert.next(alertData);
    }
}